import store from "./store";

const getToken = () => {
  const state = store.getState();
  return state?.auth?.authData?.access_token;
};

export default getToken;
